import axios from 'axios';
import API from './api';
const groupService = {
    getGroupInfo(GroupId) {
        return new Promise((resolve, reject) => {
            axios.get(`${API.localhost}/v1/group/getGroupInfoResource?group_id=${GroupId.toString()}`)
                .then(res => {
                    resolve(res.data);
                }).catch(err => {
                    reject(err);
                });
        });
    },
    isInGroup(GroupId, UserId,yiban_id,user_token) {
        return new Promise((resolve, reject) => {
            axios.get(`${API.localhost}/v1/group/isInGroupResource?group_id=${GroupId.toString()}&user_id=${UserId.toString()}&user_token=${user_token}&yiban_id=${yiban_id}`)
                .then(res => {
                    resolve(res.data);
                }).catch(err => {
                    reject(err);
                });
        });     
    },
    joinGroup(GroupId, SessionId) {
        return new Promise((resolve, reject) => {
            axios.post(`${API.localhost}/v1/group/joinGroupResource?group_id=${GroupId.toString()}`, {
                session_id: SessionId
            })
                .then(res => {
                    resolve(res.data);
                }).catch(err => {
                    reject(err);
                });
        });
    }
}
export { groupService };